import React, {useCallback} from 'react';

import {TREE_NAMES, TreeSkeleton, updateHiddenFeatures} from 'src/components/features-section';
import {Skeleton} from 'src/components/skeleton';

import CheckBoxTree from '@pb/kit-component-checkbox-tree';
import Group from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';

import type {ChangeTreeType} from '@pb/kit-component-checkbox-tree';
import type {TreeStructure} from '@pb/kit-component-tree-v2';


type Props = {
    exportOptionsTree: TreeStructure | null,
    loading: boolean,
    platformFeatures: Array<string>,
    onChange: (platformFeatures: Array<string>) => void,
    layoutLevel?: number,
};

export const ExportOptionsSection: React.FC<Props> = props => {
    const {loading, exportOptionsTree, platformFeatures, onChange, layoutLevel} = props;
    const onChangeTree = useCallback((changeTreeType: ChangeTreeType) => {
        onChange(updateHiddenFeatures(platformFeatures, changeTreeType));
    }, [platformFeatures, onChange]);

    return (
        <Skeleton view={<TreeSkeleton rows={3}/>} shown={loading}>
            <Group direction="v" gap="m">
                <Label>Export Options</Label>
                {exportOptionsTree ? (
                    <CheckBoxTree
                        data={exportOptionsTree}
                        onChange={onChangeTree}
                        name={TREE_NAMES.EXPORT_OPTIONS}
                        checkedIdsList={platformFeatures}
                        layoutLevel={layoutLevel}
                    />
                ) : null}
            </Group>
        </Skeleton>
    );
};
